import { createSlice } from "@reduxjs/toolkit";
import { TTopUpFilters } from "../../types/ernergyRecon";

export interface State {
  payload: TTopUpFilters;
}

const slice = createSlice({
  name: "topUpFilters",
  initialState: { payload: {} } as State,
  reducers: {
    topUpFilters: (state, { payload }: State) => {
      state.payload = payload;
    }
  }
});

export const { topUpFilters } = slice.actions;
export default slice.reducer;
